enum SourceEnum {
    Bing = 'BING',
    Facebook = 'FACEBOOK',
    FacebookPaid = 'FACEBOOK_PAID',
    Google = 'GOOGLE',
}

export default SourceEnum;
